import ArchiveSeasonStandingsDb from "./ArchiveSeasonStandingsDb.jsx";

export default function ArchiveSeasonStandingsProDb() {
    return (
        <ArchiveSeasonStandingsDb
            scopeType="DRIVER"
            classKey="PRO"
            title="Archiv Standings PRO"
            pillLabel="PRO"
        />
    );
}
